const containsOnlySemicolons = (inputString: string): boolean => {
  // Define a regular expression pattern that matches only semicolons
  const pattern = /^;+$/

  // Use RegExp.test to check if the entire string matches the pattern
  return pattern.test(inputString)
}

export { containsOnlySemicolons }
